function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityShipmentOutgoing = function SvgActivityShipmentOutgoing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 10.8-1.2-6.2a2.56 2.56 0 0 0-2.5-2h-2.2A2.582 2.582 0 0 0 14 0H1.2a.876.876 0 0 0-.9.8v.1a.86.86 0 0 0 .8.8h12.7a.713.713 0 0 1 .6.3.908.908 0 0 1 .3.7V11a2.286 2.286 0 0 0-.7 1h-4a2.591 2.591 0 0 0-2.4-1.7A2.725 2.725 0 0 0 5.1 12H2.6a.9.9 0 0 1-.9-.9.773.773 0 0 0-.7-.8H.9a.789.789 0 0 0-.8.8 2.647 2.647 0 0 0 2.6 2.6h2.6a2.688 2.688 0 0 0 5 0h4a2.591 2.591 0 0 0 2.4 1.7 2.725 2.725 0 0 0 2.5-1.7h.8a2.518 2.518 0 0 0 2-.9 2.635 2.635 0 0 0 .5-2zm-13.9 2a.9.9 0 0 1-.9.9.713.713 0 0 1-.6-.3.864.864 0 0 1-.3-.6.9.9 0 0 1 .9-.9h.1c.3 0 .7.5.8.9zm7.9-8.6h2.2a.961.961 0 0 1 .9.7l.2 1h-3.3V4.2zm.8 9.3a.864.864 0 0 1-.6.3.882.882 0 0 1-.9-.8.9.9 0 0 1 .9-.9.882.882 0 0 1 .9.8.6.6 0 0 1-.3.6zm3.3-1.8a.908.908 0 0 1-.7.3H19a2.591 2.591 0 0 0-2.4-1.7h-.1V7.6h3.6l.6 3.3a.605.605 0 0 1-.1.8z",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(4.541 3.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7.8a.789.789 0 0 1-.8.8H.8c-.4.1-.8-.3-.8-.8A.789.789 0 0 1 .8 0h6a.817.817 0 0 1 .9.8z",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(2.18 8.161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6.8a.789.789 0 0 1-.8.8h-6c-.4.1-.8-.3-.8-.8A.789.789 0 0 1 .8 0h6a.789.789 0 0 1 .8.8z",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(3.43 5.661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6.8a.789.789 0 0 1-.8.8h-6A.709.709 0 0 1 0 .9V.8A.86.86 0 0 1 .8 0h6c.5.1.8.4.8.8z",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(1 10.591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v22H0z",
    "data-name": "Rectangle 4782",
    style: {
      fill: "none",
      opacity: 0.28
    }
  }));
};
export default SvgActivityShipmentOutgoing;